import {
    ADDTOCART,
    DECREMENT,
    INCREMENT,
    TOTALITEM,
    TOTALPRICE,
} from "./actions";

export const addtocart = (data) => {
    return {
        type: ADDTOCART,
        payload: data,
    };
};

export const inc = (data) => {
    return {
        type: INCREMENT,
        payload: data,
    };
};

export const dec = (data) => {
    return {
        type: DECREMENT,
        payload: data,
    };
};

export const totalitem = (data) => {
    return {
        type: TOTALITEM,
        payload: data,
    };
};

export const totalprice = (data) => {
    return {
        type: TOTALPRICE,
        payload: data,
    };
};
